import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { exampleDepartmentsTitles } from 'src/app/styleguide/exampledata/example-entities';
import { IconComponent } from '@teamfoster/sdk/icon';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-content-block-map',
    imports: [ResizeHtmlImagesPipe, StripEmbedPipe, SafePipe, IconComponent, FromDictionaryPipe, RouterLink],
    templateUrl: './content-block-map.component.html',
    styleUrl: './content-block-map.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBlockMapComponent extends ContentBlockBaseComponent {
  //markers = exampleDepartmentsTitles;
  activeMarker: number | null = null;

  markers = [
    { id: 2, posX: 41, posY: 19, dict: 'museum', routerLink: '/museum' },
    { id: 3, posX: 53, posY: 60, dict: 'bibliotheek', routerLink: '/bibliotheek' },
    { id: 1, posX: 87, posY: 61, dict: 'experienceLab', routerLink: '/experiencelab' },
    { id: 0, posX: 75, posY: 68, dict: 'archief', routerLink: '/archief' },
  ];
}
